<div class="tool-settings-bar row">
  <div id="left-bar" class="col-12 col-lg-5">
    <div class="col-12 px-2" *ngFor="let filter of filters">
      <div class="form-group">
        <label *ngIf="filter.type !== 'autocomplete'">{{ filter.label }}</label>
        <input
          *ngIf="filter.type === 'text'"
          id="tool-search-input"
          type="text"
          class="form-control"
          [placeholder]="'Select ' + filter.label.toLowerCase()"
          (keyup.enter)="submitFilters(filter.propertyName, $event)" />
        <ng-container *ngIf="filter.type === 'date-range'">
          <input
            type="text"
            class="form-control"
            style="height: 32px"
            name="daterange"
            startKey="start"
            endKey="end"
            [showClearButton]="true"
            [showCancel]="true"
            [(ngModel)]="selectedDateRange"
            (change)="submitDaterangeFilter(filter.propertyName, $event)"
            (clearClicked)="clearDaterangeFilter(filter.propertyName)"
            ngxDaterangepickerMd
            #assignedDateRange
            placeholder="Select a date range" />
        </ng-container>
        <ng-container *ngIf="filter.model === 'batchId'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [bindVal]="filter.value"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #batchNumberFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>

        <ng-container *ngIf="filter.model === 'inventory'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="flat"
            [inputItems]="filter.options"
            #inventoryFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>

        <ng-container *ngIf="filter.model === 'assignedTo'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [bindVal]="filter.value"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #assignedToFilter
            (loadOptions)="filter.loadOptions()"
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'assignedFrom'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [bindVal]="filter.value"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #assignedFromFilter
            (loadOptions)="filter.loadOptions()"
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'assignedBy'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [bindVal]="filter.value"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #assignedByFilter
            (loadOptions)="filter.loadOptions()"
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'tools'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [bindVal]="filter.value"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #toolsFilter
            (keyup)="toolIdSearch($event)"
            (loadOptions)="filter.loadOptions()"
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'employees'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #employeesFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'categories'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #categoriesFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'departments'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #departmentsFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'manufacturers'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #manufacturersFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'jobs'">
          <label>{{ filter.label }}</label>
          <app-job-search-box
            #jobsAutocomplete
            dropdownType="multiple"
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-job-search-box>
        </ng-container>
        <ng-container *ngIf="filter.model === 'enabled'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="single"
            [inputItems]="filter.options"
            #statusFilter
            (filter)="submitSingleFilter(filter.propertyName, $event)">
          </app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'asset-classes'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #assetClassDropDownFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'owner'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #ownerFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
        <ng-container *ngIf="filter.model === 'shop-locations'">
          <app-autocomplete-dropdown
            [model]="filter.model"
            [bindLabel]="filter.name"
            [propertyName]="filter.propertyName"
            [type]="filterType"
            [label]="filter.label"
            dropdownType="multiple"
            [inputItems]="filter.options"
            #shopFilter
            (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
        </ng-container>
      </div>
    </div>
    <div *ngIf="toolSettingsData.type == 'transfers'" id="search-input" class="col-12 px-2">
      <div class="form-wrapper">
        <div class="form-group">
          <label class="hidden">Search</label>
          <input
            [(ngModel)]="searchInput"
            id="tool-search-input"
            type="text"
            style="height: 32px"
            class="form-control"
            placeholder="Search"
            (keyup.enter)="submitSearch()" />
          <button type="button" class="right" (click)="submitSearch()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="toolSettingsData.type == 'transfers'" class="rental-rates-container custom-control custom-checkbox">
      <input
        (change)="includeRentalRatesChecked($event)"
        [(ngModel)]="rentalRatesIncluded"
        [checked]="rentalRatesIncluded"
        type="checkbox"
        class="custom-control-input"
        id="customCheck88" />
      <label class="custom-control-label" for="customCheck88">Include Rental Rates</label>
    </div>
    <!-- Search Bar -->
    <div
      *ngIf="searchBarSide === 'right' && toolSettingsData.type !== 'transfers'"
      id="search-input"
      class="col-12 col-sm-6 col-md px-2">
      <div style="position: relative">
        <div class="form-group">
          <label>Search</label>
          <input
            [(ngModel)]="searchInput"
            style="height: 32px"
            id="tool-search-input"
            type="text"
            class="form-control"
            placeholder="Search"
            (keyup.enter)="submitSearch()" />
          <button type="button" class="right" (click)="submitSearch()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Fleet Vehicle Search -->
    <div
      *ngIf="searchBarSide === 'right' && toolSettingsData.type == 'tools'"
      id="fleet-input"
      class="col-12 col-sm-6 col-md px-2">
      <div style="position: relative">
        <div class="form-group">
          <label>Fleet Vehicle #</label>
          <input
            [(ngModel)]="fleetVehicleInput"
            style="height: 32px"
            id="fleet-vehicle-input"
            type="text"
            class="form-control"
            placeholder="#FVN"
            (keyup.enter)="submitFleetSearch()" />
          <button type="button" class="right" (click)="submitFleetSearch()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="searchBarSide === 'left'" class="col-12 col-sm-6 col-md col-lg-3 px-2">
      <div id="search-input" style="position: relative">
        <div class="form-group">
          <label style="visibility: hidden">Search</label>
          <input
            [(ngModel)]="searchInput"
            id="tool-search-input"
            type="text"
            class="form-control"
            placeholder="Search"
            (keyup.enter)="submitSearch()" />
          <button type="button" class="" (click)="submitSearch()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div id="right-bar" class="col d-flex">
    <!-- More Filters -->
    <ng-container *ngIf="toolSettingsData.type == 'tools'">
      <button
        type="button"
        id="more-filter-button"
        class="btn btn-outline-primary more-filter-button"
        data-toggle="modal"
        data-target="#moreFilter">
        More Filters
        <span class="dot">.</span> 4
      </button>
    </ng-container>
    <ng-container *ngIf="isAllowed(toolSettingsData.type, 'edit')">
      <button
        *ngIf="toolSettingsData.type == 'tools'"
        type="button"
        id="tool-setting-add-button"
        class="btn btn-primary"
        (click)="emitTransfer()">
        Transfer ({{ transferCount }})
      </button>
    </ng-container>

    <ng-container *ngIf="toolSettingsData.type == 'transfers'">
      <button class="btn btn-success" (click)="submitSearch()" id="transfers-save">Search</button>
    </ng-container>

    <ng-container *ngIf="toolSettingsData.type == 'transfers'">
      <button class="btn btn-light text-dark" (click)="clearFilter()" id="transfers-clear">Clear</button>
    </ng-container>

    <ng-container *ngIf="toolSettingsData.type == 'inventories'">
      <button
        type="button"
        id="tool-inventory-add-button"
        class="btn btn-info"
        (click)="emitInventory()"
        [disabled]="!userPermissions.tool_inventory.edit">
        Inventory ({{ inventoryCount }})
      </button>
    </ng-container>

    <ng-container *ngIf="toolSettingsData.type == 'inventories'">
      <button
        type="button"
        id="tool-inventory-transfer-button"
        class="btn btn-primary"
        (click)="emitInventoryTransfer()"
        [disabled]="!userPermissions.tool_inventory.edit">
        Transfer ({{ inventoryCount }})
      </button>
    </ng-container>

    <!-- Export -->
    <div class="dropdown">
      <button
        class="btn btn-primary dropdown-toggle"
        [disabled]="checkIsExportButtonDisabled()"
        type="button"
        id="tools-export"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        Export
      </button>
      <div class="dropdown-menu" aria-labelledby="tools-export">
        <a class="dropdown-item">
          <button
            type="button"
            class="btn"
            (mousedown)="setToolExportType('default')"
            (click)="emitExport(toolSettingsData.type)">
            {{ capitalize(toolSettingsData.type) }} Export File
          </button>
        </a>
        <a class="dropdown-item" *ngIf="toolSettingsData.type == 'tools'">
          <button
            type="button"
            class="btn"
            (mousedown)="setToolExportType('assistant')"
            (click)="emitExport(toolSettingsData.type)">
            Assistant Export File
          </button>
        </a>
      </div>
    </div>
    <ng-container *ngIf="isAllowed(toolSettingsData.type, 'edit')">
      <button type="button" id="tool-setting-add-button" class="btn btn-primary" (click)="submitCreate()">
        Add {{ toolSettingsData.label }}
      </button>
    </ng-container>
  </div>
</div>
<div class="filter-options" *ngIf="['tools', 'models', 'inventories'].includes(toolSettingsData.type)">
  <ul class="list-unstyled d-flex">
    <li><a href="javascript:;" (click)="saveFilter()">Save Filters</a></li>
    <li class="divider">|</li>
    <li><a href="javascript:;" (click)="clearFilter()">Clear Filters</a></li>
  </ul>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="moreFilter" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm">
        <div class="modal-header">
          <h5 class="modal-title">More Filters</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body" *ngFor="let filter of moreFilters">
          <ng-container *ngIf="filter.model === 'asset-classes'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #assetClassDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
          <!-- status -->
          <ng-container *ngIf="filter.model === 'assignment_types'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #assignmentTypesDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
          <!-- Shop Origination -->
          <ng-container *ngIf="filter.model === 'shop_origination_id'">
            <app-autocomplete-dropdown
              [model]="filter.model"
              [bindLabel]="filter.name"
              [propertyName]="filter.propertyName"
              [type]="filterType"
              [label]="filter.label"
              dropdownType="multiple"
              [inputItems]="filter.options"
              #shopOriginationDropDownFilter
              (filter)="submitAutocompleteMultipleFilter(filter.propertyName, $event)"></app-autocomplete-dropdown>
          </ng-container>
          <ng-container *ngIf="filter.model === 'is_vehicle'">
            <!-- Is Vehicle -->
            <div
              class="custom-control custom-checkbox col-12 px-2 d-flex align-items-center justify-content-start ml-3">
              <input
                (change)="vehicleModelsChecked($event)"
                [checked]="isVehicleModel"
                type="checkbox"
                class="custom-control-input"
                id="customCheck89" />
              <label class="custom-control-label" for="customCheck89">{{ filter.label }}</label>
            </div>
          </ng-container>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closeFilterModel data-dismiss="modal">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Filter Modal End-->
